import React, { Component } from "react";
import { message, Switch, Input } from "antd";
import { operation_service } from "../service/operation.service";
import { machine_service } from "../service/mahcine.service";
import "antd/dist/antd.css";
import { DatePicker, List, LocaleProvider, Modal, InputItem, Button, Slider } from "antd-mobile";
import zhCN from "antd-mobile/lib/locale-provider/locale-provider";
import { Collapse } from 'react-collapse';

class SettingSelect extends Component {
  constructor(props) {
    super(props);
    this.timingOkClick = this.timingOkClick.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.usernameChangeOk = this.usernameChangeOk.bind(this);
    this.onStartTimeOk = this.onStartTimeOk.bind(this);
    this.onEndTimeOk = this.onEndTimeOk.bind(this);
    this.obtainFilterIsOpen = this.obtainFilterIsOpen.bind(this);
    this.onfilterSwitch = this.onfilterSwitch.bind(this);
    this.onVolumeSwitch = this.onVolumeSwitch.bind(this);
    this.obtainVolumeIsOpen = this.obtainVolumeIsOpen.bind(this);
    this.onMainFilterSwitch = this.onMainFilterSwitch.bind(this);
    this.obtainMainFilterIsOpen = this.obtainMainFilterIsOpen.bind(this);
    this.obtainUserAuthority = this.obtainUserAuthority.bind(this)
    this.setTimingVolumeShow = this.setTimingVolumeShow.bind(this);
    this.setTimingVolume = this.setTimingVolume.bind(this);
    this.handleVolumeTimingCancel = this.handleVolumeTimingCancel.bind(this);
    this.onVolumeTimingStartTimeOk = this.onVolumeTimingStartTimeOk.bind(this);
    this.onVolumeTimingEndTimeOk = this.onVolumeTimingEndTimeOk.bind(this);
    this.loadTimingVolumeData = this.loadTimingVolumeData.bind(this);
    this.loadVolumeRange = this.loadVolumeRange.bind(this);
    this.onVolumeTimingSwitchChange = this.onVolumeTimingSwitchChange.bind(this);
    this.deleteTimingVolume = this.deleteTimingVolume.bind(this);

    this.state = {
      hideVolumeIfObtain: true,
      mainFilterIfObtain: true,
      userAuthority: false,
      // 定时调速相关状态
      volume_timing_list: [],
      volume_timing_visible: false,
      volume_timing_switch: false, // 开关状态
      volume_timing_start_time: null,
      volume_timing_end_time: null,
      volume_timing_start_speed: null,
      volume_timing_end_speed: null,
      volume_timing_editing_index: null, // 正在编辑的索引，null表示新增
      volume_timing_start_speed_modal_visible: false, // 开始风量配置弹窗
      volume_timing_end_speed_modal_visible: false, // 结束风量配置弹窗
      volumeMin: 30,
      volumeMax: 320,
      modelId: ''
    }
  }

  componentDidMount() {

    this.props.startTimeChange(new Date("2018/12/14 21:00:00"));
    this.props.endTimeChange(new Date("2018/12/15 09:00:00"));
    this.obtainFilterIsOpen(this.props.qrcode);
    this.obtainVolumeIsOpen(this.props.qrcode);
    this.obtainMainFilterIsOpen(this.props.qrcode);
    this.obtainUserAuthority(this.props.qrcode);
    this.loadVolumeRange();
    // 只有 28A308B152732 这个二维码才加载定时调速数据
    if (this.isTimingVolumeEnabled()) {
      this.loadTimingVolumeData();
    }
  }

  //滤网提醒是否打开
  obtainFilterIsOpen(qrcode) {
    machine_service.obtain_filter_isOpen(qrcode).then((response) => {
      if (response.responseCode === "RESPONSE_OK") {
        if (response.data.isOpen) {
          this.props.filterSwitchOn();
        } else {
          this.props.filterSwitchOff();
        }
      }
    });
  }

  //高效滤网提醒是否打开
  obtainMainFilterIsOpen(qrcode) {
    machine_service.obtain_mainFilter_isOpen(qrcode).then((response) => {
      if (response.responseCode === "RESPONSE_OK") {
        if (response.data.isOpen) {
          this.props.mainFilterSwitchOn();
        } else {
          this.props.mainFilterSwitchOff();
        }
      } else {
        this.setState({
          mainFilterIfObtain: false,
        })
      }
    })
  }


  //是否开启隐藏风量
  obtainVolumeIsOpen(qrcode) {
    machine_service.obtain_turboVolume_status(qrcode).then((response) => {
      if (response.responseCode === "RESPONSE_OK") {
        if (response.data.turboVolumeStatus) {
          this.props.volumeSwitchOn();
        } else {
          this.props.volumeSwitchOff();
        }

      }
      else if (response.responseCode === "RESPONSE_ERROR") {
        //没有隐藏风量
        this.setState({ hideVolumeIfObtain: false })
      }
    })

  }


  onSwitchChange(e) {
    if (e === true) {
      this.props.switchOn();
    } else {
      this.props.switchOff();
      operation_service.start_timing(
        this.props.qrcode,
        this.props.start_hour,
        this.props.start_minute,
        this.props.end_hour,
        this.props.end_minute,
        e
      );
    }
    this.props.expandTiming();
  }

  onStartTimeOk(e) {
    this.props.changeStartHour(e.getHours());
    this.props.changeStartMinute(e.getMinutes());
    this.props.startTimeChange(e);
  }

  onEndTimeOk(e) {
    this.props.changeEndHour(e.getHours());
    this.props.changeEndMinute(e.getMinutes());
    this.props.endTimeChange(e);
  }

  timingOkClick() {
    operation_service
      .start_timing(
        this.props.qrcode,
        this.props.start_hour,
        this.props.start_minute,
        this.props.end_hour,
        this.props.end_minute,
        this.props.switch
      )
      .then((response) => {
        if (response.responseCode === "RESPONSE_OK") {
          message.success("设置成功", 1);
        } else {
          message.error("设置异常", 1);
        }
      });
  }

  usernameChangeOk(e) {
    if (e.target.value === "") {
      message.warning("不能为空", 1);
      this.props.inputUsername(this.props.username);
      this.props.usernameOkClick();
    } else {
      machine_service.config_bind_name(this.props.qrcode, e.target.value);
      this.props.inputUsername(e.target.value);
      this.props.usernameOkClick();
    }
  }

  //滤网提醒
  onfilterSwitch(e) {
    let alert = Modal.alert;
    if (e === true) {
      alert("温馨提示", "开启初滤网清洁提醒后您将接收到微信的消息通知，确定请点击开启", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "开启", onPress: () => {
            this.props.filterSwitchOn();
            machine_service.change_filter_status(this.props.qrcode, true);
          }
        },
      ]);

    } else {
      alert("温馨提示", "关闭初滤网清洁提醒后您将不会接收到微信的消息通知，确定请点击关闭", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "关闭", onPress: () => {
            this.props.filterSwitchOff();
            machine_service.change_filter_status(this.props.qrcode, false);
          }
        },
      ]);

    }
  }

  //高效滤网更换提醒
  onMainFilterSwitch(e) {
    let mainFilterAlert = Modal.alert;
    if (e === true) {
      mainFilterAlert("温馨提示", "开启高效滤网更换提醒后您将接收到微信的消息通知，确定请点击开启", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "开启", onPress: () => {
            this.props.mainFilterSwitchOn();
            machine_service.change_mainFilter_isOpen(this.props.qrcode, true);

          }
        },
      ]);

    } else {
      mainFilterAlert("温馨提示", "关闭高效滤网更换提醒后您将不会接收到微信的消息通知，确定请点击关闭", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "关闭", onPress: () => {
            this.props.mainFilterSwitchOff();
            machine_service.change_mainFilter_isOpen(this.props.qrcode, false);
          }
        },
      ]);

    }
  }

  //开启风扇隐藏风量
  onVolumeSwitch(e) {
    let volumeAlert = Modal.alert;
    if (e === true) {
      volumeAlert("温馨提示", "开启超净风量后风量可调节范围将扩大，确定请点击开启", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "开启", onPress: () => {
            this.props.volumeSwitchOn();
            machine_service.change_turboVolume_status(this.props.qrcode, true);
          }
        },
      ]);

    } else {
      volumeAlert("温馨提示", "关闭超净风量后风量可调节范围将缩小，确定请点击关闭", [
        { text: "取消", onPress: () => console.log("cancel") },
        {
          text: "关闭", onPress: () => {
            this.props.volumeSwitchOff();
            machine_service.change_turboVolume_status(this.props.qrcode, false);
          }
        },
      ]);

    }
  }

  //用户是否拥有设备管理权限
  obtainUserAuthority(qrcode) {
    machine_service.obtain_bind_info(qrcode).then((response) => {
      if (response.responseCode === "RESPONSE_OK") {
        this.setState({
          userAuthority: response.data[0].ownership
        })
      }
    })
  }

  // 加载风量范围
  loadVolumeRange() {
    machine_service.check_exist(this.props.qrcode).then(response => {
      if (response.responseCode === 'RESPONSE_OK') {
        let modelId = response.data[0].modelId;
        this.setState({ modelId: modelId });
        machine_service.obtain_volume_range(modelId).then(volumeResponse => {
          if (volumeResponse.responseCode === "RESPONSE_OK" && volumeResponse.data && volumeResponse.data[0]) {
            let min = volumeResponse.data[0].minVolume || 30;
            let max = volumeResponse.data[0].maxVolume || 280;
            this.setState({
              volumeMin: min,
              volumeMax: max
            });
          }
        });
        machine_service.obtain_turboVolume_range(this.props.qrcode).then(turboResponse => {
          if (turboResponse.responseCode === "RESPONSE_OK" && turboResponse.data) {
            if (turboResponse.data.turboVolume && turboResponse.data.turboVolume > this.state.volumeMax) {
              this.setState({
                volumeMax: turboResponse.data.turboVolume
              });
            }
          }
        });
      }
    });
  }

  // 检查是否启用定时调速功能（只有 28A308B152732 这个二维码才启用）
  isTimingVolumeEnabled() {
    const TIMING_VOLUME_QRCODES = new Set([
      '28A308B152732',
      '28P601A012899',
      '42S316A265930',
      '28A405A918281',
      '42S606A563176',
      '28L709Y227965',
      '28L709Y436467',
      '28L709Y447766',
      '42S504A985048',
      '28P601A748361',
      '28P601A598322',
      '28L709A117144',
      '28L709A388840',
      '42L708Z105078',
      '28L811A243427',
      '28L811A005506',
      '28L709Y428249',
      '52L903A020683',
      '52L903A051980',
      '28L811A412629',
      '28L811A467894',
      '28L811A170693',
      '28L811A376469',
      '28L811A388809',
      '42S207B226460',
      '42A110B647164',
      '52L903A021658',
      '28L811A087122',
      '52L903A077075',
      '52B206C391391'
    ]);

    return TIMING_VOLUME_QRCODES.has(this.props.qrcode);
  }

  // 加载定时调速数据
  loadTimingVolumeData() {
    operation_service.obtain_timing_volume(this.props.qrcode).then(response => {
      if (response.responseCode === "RESPONSE_OK") {
        let dataList = response.data || [];
        if (!Array.isArray(dataList)) {
          dataList = [dataList];
        }
        let formattedList = dataList.map((item, index) => {
          let on_off_temp = "关闭";
          // 使用 enableFlag 判断启用状态，true 表示启用
          if (item.enableFlag === true) {
            on_off_temp = "开启";
          }
          let start_time_temp = this.formatTime(item.startTime);
          let end_time_temp = this.formatTime(item.endTime);
          return {
            key: index,
            configId: item.configId, // 保存 configId 用于删除
            status: on_off_temp,
            enableFlag: item.enableFlag, // 保存 enableFlag 状态
            startTime: start_time_temp,
            endTime: end_time_temp,
            startSpeed: item.startSpeed,
            endSpeed: item.endSpeed
          };
        });
        this.setState({
          volume_timing_list: formattedList
        });
      } else if (response.responseCode === "RESPONSE_NULL") {
        this.setState({
          volume_timing_list: []
        });
      } else {
        this.setState({
          volume_timing_list: []
        });
      }
    });
  }

  formatTime(time) {
    if (time == null) {
      return '';
    }
    let hour = ("0" + time.hour).slice(-2).toString();
    let minute = ("0" + time.minute).slice(-2).toString();
    return hour + ":" + minute;
  }

  // 定时调速相关方法
  setTimingVolumeShow(editingIndex = null) {
    // 设置默认时间为当前时间，分钟数向下取整到30分钟
    const now = new Date();
    const defaultStartMinute = Math.floor(now.getMinutes() / 30) * 30;
    const defaultStartTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), defaultStartMinute, 0);

    // 结束时间默认为开始时间后1小时
    const defaultEndTime = new Date(defaultStartTime);
    defaultEndTime.setHours(defaultEndTime.getHours() + 1);

    // 如果是编辑模式，填充现有数据
    let startTime = defaultStartTime;
    let endTime = defaultEndTime;
    let startSpeed = this.state.volumeMin;
    let endSpeed = this.state.volumeMin;

    if (editingIndex !== null && this.state.volume_timing_list[editingIndex]) {
      const item = this.state.volume_timing_list[editingIndex];
      // 解析时间字符串
      const startTimeStr = item.startTime.split(':');
      const endTimeStr = item.endTime.split(':');
      startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(startTimeStr[0]), parseInt(startTimeStr[1]), 0);
      endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(endTimeStr[0]), parseInt(endTimeStr[1]), 0);
      startSpeed = item.startSpeed != null ? item.startSpeed : this.state.volumeMin;
      endSpeed = item.endSpeed != null ? item.endSpeed : this.state.volumeMin;
    }

    this.setState({
      volume_timing_visible: true,
      volume_timing_editing_index: editingIndex,
      volume_timing_start_time: startTime,
      volume_timing_end_time: endTime,
      volume_timing_start_speed: startSpeed,
      volume_timing_end_speed: endSpeed,
      volume_timing_start_speed_modal_visible: false,
      volume_timing_end_speed_modal_visible: false
    });
  }

  handleVolumeTimingCancel() {
    this.setState({
      volume_timing_visible: false,
      volume_timing_editing_index: null,
      volume_timing_start_time: null,
      volume_timing_end_time: null,
      volume_timing_start_speed: null,
      volume_timing_end_speed: null,
      volume_timing_start_speed_modal_visible: false,
      volume_timing_end_speed_modal_visible: false
    });
  }

  onVolumeTimingStartSpeedOk = () => {
    this.setState({ volume_timing_start_speed_modal_visible: false });
  }

  onVolumeTimingEndSpeedOk = () => {
    this.setState({ volume_timing_end_speed_modal_visible: false });
  }

  onVolumeTimingStartTimeOk(e) {
    this.setState({
      volume_timing_start_time: e
    });
  }

  onVolumeTimingEndTimeOk(e) {
    this.setState({
      volume_timing_end_time: e
    });
  }

  // 单条定时调速 开启/关闭 快捷按钮
  toggleTimingVolumeEnable(index) {
    const item = this.state.volume_timing_list[index];
    if (!item || !item.configId) {
      message.warning("无法获取配置ID，操作失败", 1);
      return;
    }

    const isEnable = item.enableFlag === true;
    const request = isEnable
      ? operation_service.disable_timing_volume(item.configId)
      : operation_service.enable_timing_volume(item.configId);

    request.then(response => {
      if (response.responseCode === "RESPONSE_OK") {
        message.success(isEnable ? "已关闭" : "已开启", 1);
        this.loadTimingVolumeData();
      } else {
        message.error(response.description || "操作失败", 1);
      }
    });
  }

  adjustVolumeTiming(delta, isStartSpeed = true) {
    const { volumeMin, volumeMax } = this.state;
    const stateKey = isStartSpeed ? 'volume_timing_start_speed' : 'volume_timing_end_speed';
    let currentValue = this.state[stateKey] || volumeMin;
    let newValue = currentValue + delta;

    // 不超过上下限
    if (newValue < volumeMin) newValue = volumeMin;
    if (newValue > volumeMax) newValue = volumeMax;

    // 确保是5的倍数
    newValue = Math.round(newValue / 5) * 5;

    this.setState({ [stateKey]: newValue });
  }

  setTimingVolume() {
    if (this.state.volume_timing_start_time === null || this.state.volume_timing_end_time === null ||
      this.state.volume_timing_start_speed === null || this.state.volume_timing_end_speed === null) {
      message.warning("请输入完整数据!", 1);
      return;
    }
    // Slider 组件已经限制了范围，这里可以移除范围检查，但保留以防万一
    if (this.state.volume_timing_start_speed < this.state.volumeMin || this.state.volume_timing_start_speed > this.state.volumeMax) {
      message.warning(`请输入有效的开始风量值(${this.state.volumeMin}-${this.state.volumeMax})!`, 1);
      return;
    }
    if (this.state.volume_timing_end_speed < this.state.volumeMin || this.state.volume_timing_end_speed > this.state.volumeMax) {
      message.warning(`请输入有效的结束风量值(${this.state.volumeMin}-${this.state.volumeMax})!`, 1);
      return;
    }
    let start_hour = this.state.volume_timing_start_time ? this.state.volume_timing_start_time.getHours() : 0;
    let start_minute = this.state.volume_timing_start_time ? this.state.volume_timing_start_time.getMinutes() : 0;
    let end_hour = this.state.volume_timing_end_time ? this.state.volume_timing_end_time.getHours() : 0;
    let end_minute = this.state.volume_timing_end_time ? this.state.volume_timing_end_time.getMinutes() : 0;
    let start_speed = this.state.volume_timing_start_speed;
    let end_speed = this.state.volume_timing_end_speed;

    // 判断是新增还是编辑
    const isEditing = this.state.volume_timing_editing_index !== null;
    let request;

    if (isEditing) {
      // 编辑模式：需要获取 configId
      const editingItem = this.state.volume_timing_list[this.state.volume_timing_editing_index];
      if (!editingItem || !editingItem.configId) {
        message.warning("无法获取配置ID，编辑失败", 1);
        return;
      }
      request = operation_service.update_timing_volume(
        editingItem.configId,
        this.props.qrcode,
        start_hour,
        start_minute,
        end_hour,
        end_minute,
        start_speed,
        end_speed
      );
    } else {
      // 新增模式
      request = operation_service.set_timing_volume(
        this.props.qrcode,
        start_hour,
        start_minute,
        end_hour,
        end_minute,
        start_speed,
        end_speed
      );
    }

    request.then(response => {
      if (response.responseCode === "RESPONSE_OK") {
        message.success(isEditing ? "定时调速更新成功" : "定时调速设置成功", 1);
        this.loadTimingVolumeData();
        this.setState({
          volume_timing_visible: false,
          volume_timing_editing_index: null,
          volume_timing_start_time: null,
          volume_timing_end_time: null,
          volume_timing_start_speed: null,
          volume_timing_end_speed: null
        });
      } else {
        message.error(response.description || (isEditing ? "更新失败" : "设置失败"), 1);
      }
    });
  }

  onVolumeTimingSwitchChange() {
    const newState = !this.state.volume_timing_switch;
    this.setState({ volume_timing_switch: newState });
    if (newState) {
      this.loadTimingVolumeData();
    }
  }

  deleteTimingVolume(index) {
    const item = this.state.volume_timing_list[index];
    if (!item || !item.configId) {
      message.warning("无法获取配置ID，删除失败", 1);
      return;
    }

    operation_service.delete_timing_volume(item.configId).then(response => {
      if (response.responseCode === "RESPONSE_OK") {
        message.success("删除成功", 1);
        this.loadTimingVolumeData(); // 重新加载数据
      } else {
        message.error(response.description || "删除失败", 1);
      }
    });
  }

  render() {
    const setting_content = {
      backgroundColor: `white`,
      width: `100%`,
      borderRadius: `3px`,
    };
    const setting_gap = {
      width: `100%`,
      height: `1.4rem`,
      backgroundColor: `#dbdbdb`,
    };
    const setting_item = {
      height: `4.5rem`,
      lineHeight: `4.5rem`,
      fontSize: `1.45rem`,
      paddingRight: `6%`,
      paddingLeft: `6%`,
    };
    const inactive_setting_item = {
      height: `4.5rem`,
      lineHeight: `4.5rem`,
      fontSize: `1.45rem`,
      paddingRight: `6%`,
      paddingLeft: `6%`,
      backgroundColor: `#f2f2f2`,
    };
    const seperate_div = {
      height: `0.1rem`,
      backgroundColor: `#dbdbdb`,
    };
    console.log(this.props);
    return (
      <div>
        <div className="setting_gap" style={setting_gap} />
        <div className="setting_content" style={setting_content}>
          <div className="setting_item" style={setting_item}>
            <span>
              <i className="fa fa-user-o" aria-hidden="true" />
              &nbsp;&nbsp;设备名称
            </span>
            {!this.props.username_edit && (
              <span
                style={{ float: `right` }}
                onClick={this.props.editUsername}
              >
                {this.props.username}
              </span>
            )}
            {this.props.username_edit && (
              <span style={{ float: `right` }}>
                <Input placeholder="修改名称" onBlur={this.usernameChangeOk} />
              </span>
            )}
          </div>
        </div>
        <div className="setting_gap" style={setting_gap} />
        <div className="setting_content" style={setting_content}>
          <div className="setting_item" style={setting_item}>
            <span>
              <i className="fa fa-calendar" aria-hidden="true" />
            </span>
            &nbsp;&nbsp;定时启停
            <span style={{ float: `right` }}>
              <Switch
                onChange={this.onSwitchChange}
                checked={this.props.switch}
              />
            </span>
          </div>
          {this.props.expanded && (
            <div>
              <div className="seperate_div" style={seperate_div} />
              <div className="setting_item" style={setting_item}>
                <LocaleProvider locale={zhCN}>
                  <DatePicker
                    mode="time"
                    value={this.props.start_time}
                    minuteStep={30}
                    onOk={this.onStartTimeOk}
                  >
                    <List.Item arrow="horizontal">开始时间</List.Item>
                  </DatePicker>
                </LocaleProvider>
              </div>
              <div className="seperate_div" style={seperate_div} />
              <div className="setting_item" style={setting_item}>
                <LocaleProvider locale={zhCN}>
                  <DatePicker
                    mode="time"
                    value={this.props.end_time}
                    minuteStep={30}
                    onOk={this.onEndTimeOk}
                  >
                    <List.Item arrow="horizontal">关闭时间</List.Item>
                  </DatePicker>
                </LocaleProvider>
              </div>
              <div className="seperate_div" style={seperate_div} />
              <div className="setting_item" style={setting_item}>
                <div
                  onClick={this.timingOkClick}
                  style={{ textAlign: `center` }}
                >
                  保存
                </div>
              </div>
            </div>
          )}
          {/* 定时调速开关 - 只有 28A308B152732 这个二维码才显示 */}
          {this.isTimingVolumeEnabled() && (
            <>
              <div className="seperate_div" style={seperate_div} />
              <div
                className="setting_item"
                style={{
                  ...setting_item,
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
                onClick={this.onVolumeTimingSwitchChange}
              >
                <span>
                  <i className="fa fa-tachometer" aria-hidden="true"
                  />
                </span>
                &nbsp;&nbsp;定时调速
                <span style={{ float: `right`, alignItems: 'center', textAlign: `center`, justifyContent: 'center' }}>
                  <i
                    className={this.state.volume_timing_switch ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}
                    style={{
                      alignItems: 'center',
                      fontSize: '1rem',
                      color: '#999',
                    }}
                  />
                </span>
              </div>
              {/* 定时调速列表显示 - 带动画 */}
              <Collapse isOpened={this.state.volume_timing_switch}>
                <div>
                  {this.state.volume_timing_list.length === 0 ? (
                    <div>
                      <div className="seperate_div" style={seperate_div} />
                      <div className="setting_item" style={{
                        ...setting_item,
                        height: 'auto',
                        lineHeight: 'normal',
                        paddingTop: '1.5rem',
                        paddingBottom: '1.5rem',
                        textAlign: 'center',
                        color: '#999'
                      }}>
                        暂无定时调速配置，点击"新增"添加
                      </div>
                    </div>
                  ) : (
                    this.state.volume_timing_list.map((item, index) => (
                      <div key={item.key || index}>
                        <div className="seperate_div" style={seperate_div} />
                        <div className="setting_item" style={{
                          ...setting_item,
                          height: 'auto',
                          lineHeight: 'normal',
                          paddingTop: '1.2rem',
                          paddingBottom: '1.2rem',
                          backgroundColor: '#fff',
                          borderLeft: '3px solid #00A2E9',
                          marginLeft: '0',
                          position: 'relative'
                        }}>
                          {/* 闹钟图标 */}
                          <div style={{
                            position: 'absolute',
                            left: '1rem',
                            top: '1.2rem',
                            width: '2.5rem',
                            height: '2.5rem',
                            borderRadius: '50%',
                            backgroundColor: item.enableFlag ? '#00A2E9' : '#e0e0e0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '1.2rem'
                          }}>
                            <i className="fa fa-clock-o" />
                          </div>

                          {/* 内容区域 */}
                          <div style={{
                            marginLeft: '4rem',
                            paddingRight: '1rem'
                          }}>
                            {/* 时间显示 - 大字体 */}
                            <div style={{
                              fontSize: '1.5rem',
                              fontWeight: 'bold',
                              color: '#333',
                              marginBottom: '0.5rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '0.8rem'
                            }}>
                              <span>{item.startTime} - {item.endTime}</span>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                <Switch
                                  checked={item.enableFlag === true}
                                  onChange={(checked) => {
                                    // 阻止点击冒泡，避免触发外层折叠
                                    this.toggleTimingVolumeEnable(index);
                                  }}
                                  platform="ios"
                                  color="#00C853"
                                />
                              </div>
                            </div>

                            {/* 风量信息 */}
                            <div style={{
                              fontSize: '1.1rem',
                              color: '#666',
                              marginBottom: '0.8rem',
                              lineHeight: '1.6'
                            }}>
                              <div style={{ marginBottom: '0.3rem' }}>
                                <i className="fa fa-arrow-up" style={{ color: '#00A2E9', marginRight: '0.3rem' }} />
                                开始: {item.startSpeed != null ? item.startSpeed + ' m³/h' : '-'}
                              </div>

                              <div>
                                <i className="fa fa-arrow-down" style={{ color: '#ff6b6b', marginRight: '0.3rem' }} />
                                结束: {item.endSpeed != null ? item.endSpeed + ' m³/h' : '-'}
                              </div>
                            </div>

                            {/* 操作按钮 */}
                            <div style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              gap: '0.5rem',
                              marginTop: '0.5rem'
                            }}>
                              <Button
                                type="primary"
                                inline
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.setTimingVolumeShow(index);
                                }}
                                style={{
                                  backgroundColor: '#00A2E9',
                                  borderColor: '#00A2E9'
                                }}
                              >
                                <i className="fa fa-edit" style={{ marginRight: '0.3rem' }} />
                                编辑
                              </Button>
                              <Button
                                inline
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (window.confirm('确定要删除这条定时调速配置吗？')) {
                                    this.deleteTimingVolume(index);
                                  }
                                }}
                                style={{
                                  color: '#ff6b6b',
                                  borderColor: '#ff6b6b'
                                }}
                              >
                                <i className="fa fa-trash" style={{ marginRight: '0.3rem' }} />
                                删除
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  {/* 底部新增按钮 */}
                  <div className="seperate_div" style={seperate_div} />
                  <div className="setting_item" style={{
                    ...setting_item,
                    height: 'auto',
                    lineHeight: 'normal',
                    paddingTop: '0.8rem',
                    paddingBottom: '1.2rem',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px dashed #e0e0e0'
                  }}>
                    <div style={{ textAlign: 'center' }}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setTimingVolumeShow(null);
                        }}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0.6rem 1.6rem',
                          borderRadius: '999px',
                          border: '1px solid #00A2E9',
                          background: 'linear-gradient(135deg, #00A2E9 0%, #33c2ff 100%)',
                          color: '#fff',
                          fontSize: '1.2rem',
                          boxShadow: '0 4px 10px rgba(0, 162, 233, 0.35)',
                          cursor: 'pointer'
                        }}
                      >
                        <i className="fa fa-plus" style={{ marginRight: '0.4rem', fontSize: '1.2rem' }} />
                        新增定时
                      </button>
                    </div>
                  </div>
                </div>
              </Collapse>
            </>
          )}
          {/* 定时调速设置 Modal */}
          <Modal
            popup
            visible={this.state.volume_timing_visible}
            animationType="slide-up"
            onClose={this.handleVolumeTimingCancel}
          >
            <div style={{ padding: '1rem' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '0.8rem', textAlign: 'center' }}>
                {this.state.volume_timing_editing_index !== null ? '编辑定时调速' : '新增定时调速'}
              </div>
              <LocaleProvider locale={zhCN}>
                <DatePicker
                  mode="time"
                  value={this.state.volume_timing_start_time}
                  minuteStep={30}
                  onOk={this.onVolumeTimingStartTimeOk}
                >
                  <List.Item arrow="horizontal">开始时间</List.Item>
                </DatePicker>
              </LocaleProvider>
              <LocaleProvider locale={zhCN}>
                <DatePicker
                  mode="time"
                  value={this.state.volume_timing_end_time}
                  minuteStep={30}
                  onOk={this.onVolumeTimingEndTimeOk}
                >
                  <List.Item arrow="horizontal">结束时间</List.Item>
                </DatePicker>
              </LocaleProvider>
              <LocaleProvider locale={zhCN}>
                <Modal
                  popup
                  visible={this.state.volume_timing_start_speed_modal_visible}
                  animationType="slide-up"
                  onClose={() => this.setState({ volume_timing_start_speed_modal_visible: false })}
                >
                  <div style={{ padding: '1rem' }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.8rem', textAlign: 'center' }}>
                      开始后风量调节
                    </div>
                    <div style={{ padding: '1rem 0' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1rem' }}>
                        <button
                          style={{
                            width: '40px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px'
                          }}
                          onClick={() => this.adjustVolumeTiming(-10, true)}
                        >
                          <i className="fa fa-minus"></i>
                        </button>
                        <div style={{ flex: 1, margin: '0 10px' }}>
                          <div style={{ paddingTop: '0.5rem', paddingBottom: '1rem' }}>
                            <Slider
                              value={this.state.volume_timing_start_speed || this.state.volumeMin}
                              min={this.state.volumeMin}
                              max={this.state.volumeMax}
                              step={5}
                              onChange={(value) => {
                                this.setState({ volume_timing_start_speed: value });
                              }}
                            />
                          </div>
                          <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end'
                          }}>
                            <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'left' }}>
                              {this.state.volumeMin}
                            </div>
                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: 15, color: '#108EE9', fontWeight: 'bold' }}>
                                {this.state.volume_timing_start_speed || this.state.volumeMin} m³/h
                              </div>
                            </div>
                            <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'right' }}>
                              {this.state.volumeMax}
                            </div>
                          </div>
                        </div>
                        <button
                          style={{
                            width: '40px',
                            height: '40px',
                            border: '1px solid #00A2E9',
                            borderRadius: '4px',
                            backgroundColor: '#00A2E9',
                            color: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px'
                          }}
                          onClick={() => this.adjustVolumeTiming(10, true)}
                        >
                          <i className="fa fa-plus"></i>
                        </button>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '0.6rem',
                        padding: '0.6rem 0',
                        marginBottom: '1.5rem'
                      }}>
                        {[
                          { label: '低速', value: this.state.volumeMin },
                          { label: '中速', value: Math.round((this.state.volumeMin + this.state.volumeMax) / 2 / 5) * 5 },
                          { label: '高速', value: this.state.volumeMax },
                        ].map((item) => {
                          const currentValue = this.state.volume_timing_start_speed || this.state.volumeMin;
                          const active = Math.abs(currentValue - item.value) <= 1;
                          return (
                            <Button
                              key={item.label}
                              onClick={() => {
                                this.setState({ volume_timing_start_speed: item.value });
                              }}
                              type={active ? 'primary' : 'ghost'}
                              inline
                              size="small"
                              style={{ flex: 1 }}
                            >
                              {item.label}
                            </Button>
                          );
                        })}
                      </div>
                      <div style={{ padding: '1rem' }}>
                        <Button type="primary" onClick={this.onVolumeTimingStartSpeedOk} style={{ width: '100%' }}>确定</Button>
                      </div>
                    </div>
                  </div>
                </Modal>
              </LocaleProvider>
              <LocaleProvider locale={zhCN}>
                <List.Item
                  arrow="horizontal"
                  extra={this.state.volume_timing_start_speed ? `${this.state.volume_timing_start_speed} m³/h` : `${this.state.volumeMin} m³/h`}
                  onClick={() => this.setState({ volume_timing_start_speed_modal_visible: true })}
                >
                  开始后风量
                </List.Item>
              </LocaleProvider>
              <LocaleProvider locale={zhCN}>
                <Modal
                  popup
                  visible={this.state.volume_timing_end_speed_modal_visible}
                  animationType="slide-up"
                  onClose={() => this.setState({ volume_timing_end_speed_modal_visible: false })}
                >
                  <div style={{ padding: '1rem' }}>
                    <div style={{ fontSize: '1.5rem', marginBottom: '0.8rem', textAlign: 'center' }}>
                      结束后风量调节
                    </div>
                    <div style={{ padding: '1rem 0' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1rem' }}>
                        <button
                          style={{
                            width: '40px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px'
                          }}
                          onClick={() => this.adjustVolumeTiming(-10, false)}
                        >
                          <i className="fa fa-minus"></i>
                        </button>
                        <div style={{ flex: 1, margin: '0 10px' }}>
                          <div style={{ paddingTop: '0.5rem', paddingBottom: '1rem' }}>
                            <Slider
                              value={this.state.volume_timing_end_speed || this.state.volumeMin}
                              min={this.state.volumeMin}
                              max={this.state.volumeMax}
                              step={5}
                              onChange={(value) => {
                                this.setState({ volume_timing_end_speed: value });
                              }}
                            />
                          </div>
                          <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end'
                          }}>
                            <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'left' }}>
                              {this.state.volumeMin}
                            </div>
                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: 15, color: '#108EE9', fontWeight: 'bold' }}>
                                {this.state.volume_timing_end_speed || this.state.volumeMin} m³/h
                              </div>
                            </div>
                            <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'right' }}>
                              {this.state.volumeMax}
                            </div>
                          </div>
                        </div>
                        <button
                          style={{
                            width: '40px',
                            height: '40px',
                            border: '1px solid #00A2E9',
                            borderRadius: '4px',
                            backgroundColor: '#00A2E9',
                            color: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px'
                          }}
                          onClick={() => this.adjustVolumeTiming(10, false)}
                        >
                          <i className="fa fa-plus"></i>
                        </button>
                      </div>
                      <div style={{
                        display: 'flex',
                        gap: '0.6rem',
                        padding: '0.6rem 0'
                      }}>
                        {[
                          { label: '低速', value: this.state.volumeMin },
                          { label: '中速', value: Math.round((this.state.volumeMin + this.state.volumeMax) / 2 / 5) * 5 },
                          { label: '高速', value: this.state.volumeMax },
                        ].map((item) => {
                          const currentValue = this.state.volume_timing_end_speed || this.state.volumeMin;
                          const active = Math.abs(currentValue - item.value) <= 1;
                          return (
                            <Button
                              key={item.label}
                              onClick={() => {
                                this.setState({ volume_timing_end_speed: item.value });
                              }}
                              type={active ? 'primary' : 'ghost'}
                              inline
                              size="small"
                              style={{ flex: 1 }}
                            >
                              {item.label}
                            </Button>
                          );
                        })}
                      </div>
                      <div style={{ padding: '1rem' }}>
                        <Button type="primary" onClick={this.onVolumeTimingEndSpeedOk} style={{ width: '100%' }}>确定</Button>
                      </div>
                    </div>
                  </div>
                </Modal>
              </LocaleProvider>
              <LocaleProvider locale={zhCN}>
                <List.Item
                  arrow="horizontal"
                  extra={this.state.volume_timing_end_speed ? `${this.state.volume_timing_end_speed} m³/h` : `${this.state.volumeMin} m³/h`}
                  onClick={() => this.setState({ volume_timing_end_speed_modal_visible: true })}
                >
                  结束后风量
                </List.Item>
              </LocaleProvider>
              <div style={{ padding: '1rem' }}>
                <Button type="primary" onClick={this.setTimingVolume} style={{ marginBottom: '0.5rem' }}>保存</Button>
                <Button onClick={this.handleVolumeTimingCancel}>取消</Button>
              </div>
            </div>
          </Modal>
        </div>
        <div className="setting_gap" style={setting_gap} />
        {/*滤网提醒*/}
        <div className="setting_content" style={setting_content}>
          <div className="setting_item" style={setting_item}>
            <span>
              <i className="fa fa-table" aria-hidden="true" />
              &nbsp;&nbsp;滤网提醒
            </span>
          </div>
          <div className="seperate_div" style={seperate_div} />
          <div className="setting_item" style={setting_item}>
            <span>
              初滤网清洁
            </span>
            <span style={{ float: `right` }}>
              <Switch
                onChange={this.onfilterSwitch}
                checked={this.props.filterSwitch}
              />
            </span>
          </div>
          <div className="seperate_div" style={seperate_div} />
          {
            this.state.mainFilterIfObtain
            &&
            <div className="setting_item" style={setting_item}>
              <span>
                高效滤网更换
              </span>
              <span style={{ float: `right` }}>
                <Switch
                  onChange={this.onMainFilterSwitch}
                  checked={this.props.mainFilterSwitch}
                />
              </span>
            </div>
          }

          {/*用户权限列表，如果用户权限为OWNER则显示*/}
          {
            this.state.userAuthority == 'OWNER'
            &&
            <div>
              <div className="setting_gap" style={setting_gap} />
              <div className="setting_item" style={setting_item}>
                用户权限管理
                <span style={{ float: `right` }} onClick={() => { window.location.href = "/machine/userList/" + this.props.qrcode }}>
                  详情
                </span>
              </div>
            </div>
          }


          {/*隐藏风量开关*/}
          {
            this.state.hideVolumeIfObtain
            &&
            <div>
              <div className="setting_gap" style={setting_gap} />
              <div className="setting_item" style={setting_item}>
                <span>
                  <i className="fa fa-recycle" aria-hidden="true" />
                  &nbsp;&nbsp;超净风量
                </span>
                <span style={{ float: `right` }}>
                  <Switch
                    onChange={this.onVolumeSwitch}
                    checked={this.props.volumeSwitch}
                  />
                </span>
              </div>
            </div>

          }

        </div>

        <div className="setting_gap" style={setting_gap} />
        <div className="setting_content" style={setting_content}>
          <div className="setting_item" style={setting_item}>
            二维码
            <span style={{ float: `right` }}>{this.props.qrcode}</span>
          </div>
          <div className="seperate_div" style={seperate_div} />
          <div className="setting_item" style={setting_item}>
            版本号
            <span style={{ float: `right` }}>1.0</span>
          </div>
          <div className="seperate_div" style={seperate_div} />
          <div className="setting_item" style={setting_item}>
            固件信息
            <span style={{ float: `right` }}>1.0</span>
          </div>
          {/*<div className="seperate_div" style={seperate_div}></div>*/}
          {/*<div className="setting_item " style={inactive_setting_item}>*/}
          {/*检查更新*/}
          {/*</div>*/}
        </div>
      </div>
    );
  }
}

export default SettingSelect;
